import React from "react";
import Container from "../../components/Container/Container";
import { Col } from "react-bootstrap";

const SampleProducts = () => {
  return (
    <Container>
      <Col>
        <h1>Sample products</h1>
      </Col>
    </Container>
  );
};

export default SampleProducts;
